<template>
  <div class="refund">
    <div class="state">
      <strong>退款流程</strong>
      <span>{{ Isitcomplete }}</span>
    </div>
    <div class="refund-see" @click="clickSee">查看</div>
  </div>
</template>

<script>
import { individualOrderRefund } from "@/service/refund/touristRefundList.js";
import { getGroupOrderRefundSingle } from "@/service/refund/guideRefundDetails.js";
export default {
  name: "refund",
  props: ['itemList', 'tickettype', 'refundTicket'],
  data(){
    return {
      Isitcomplete: ''
    }
  },
  created(){
    this.getData();
  },
  methods: {
    async getData(){
      let dataList = null;
      const { orderId } = this.$route.query;
      const parameter = {
        orderId,
      };
      if(this.tickettype === 'touristorderdetails'){
        const { data } = await individualOrderRefund.call(this, parameter);
        dataList = data;
      }else{
        const { data } = await getGroupOrderRefundSingle.call(this, parameter);
        dataList = data;
      }
      if(dataList.some(item => item.payStatus == "3")){
        return this.Isitcomplete = '退款失败';
      }else if(dataList.every(item => item.payStatus == "2")){
        return this.Isitcomplete = '已完成';
      }else{
        this.Isitcomplete = '未完成';
      }
    },
    clickSee(){
      const arr = this.itemList.filter(v => v.ticketStatus === '5');
      const { orderId } = this.$route.query;
      window.sessionStorage.setItem('itemList', JSON.stringify(arr));
      this.$router.push(`/${this.refundTicket}?orderId=${orderId}`);
    }
  },
};
</script>

<style scoped lang='less'>
.refund{
  padding: .346667rem;
  background: #FFFFFF;
  border-radius: .08rem * 2;
  margin: 0 0.346667rem .186667rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .state{
    strong{
      color: #222328;
      font-size: .24rem * 2;
      font-weight: bold;
    }
    span{
      font-size: .213333rem * 2;
      margin-left: .133333rem;
    }
  }
  .refund-see{
      float: right;
      border: 1px solid #3B6D9C;
      border-radius: .08rem;
      line-height: .293333rem * 2;
      width: .853333rem * 2;
      font-size: .32rem;
      color: #3B6D9C;
      position: relative;
      padding: 0.05rem 0 0 .32rem;
      &::after{
        content: '';
        position: absolute;
        width: 0;
        height: 0;
        border-top: .053333rem * 2 solid transparent;
        border-right: .053333rem * 2 solid transparent;
        border-bottom: .053333rem * 2 solid transparent;
        border-left: .08rem * 2 solid #3B6D9C;
        right: .293333rem;
        top: 50%;
        transform: translate(50%, -50%);
      }
  }
}
</style>
